import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemProdutoAppRoutingModule } from './item-produto.app-routing.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ItemProdutoAppRoutingModule
  ]
})
export class ItemProdutoAppModule { }
